module.exports = __webpack_public_path__ + "img/skilled-communicator.59119cb0.svg";